import { addPrefix } from '../../../../constants/ids';

export const makeUnitInfoID = addPrefix((key) => `unit-info_${key}`);
